module.exports = require("./es-MX.d.ts");